module.exports = __webpack_public_path__ + "static/img/tribunal-constitucional.923fa19.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/tribunal-constitucional.png
// module id = SH5Z
// module chunks = 9